// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FoKiu2izNkxoRa5v0tSg {\n  margin-top: 150px;\n  display: flex;\n  justify-content: space-between;\n  width: 900px;\n}\n\n.QWVEQQVpploexFcm4xYH {\n  width: 55rem;\n  margin-top: 75px;\n}\n", "",{"version":3,"sources":["webpack://./src/views/Main/Main.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".main {\n  margin-top: 150px;\n  display: flex;\n  justify-content: space-between;\n  width: 900px;\n}\n\n.arraySection {\n  width: 55rem;\n  margin-top: 75px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": "FoKiu2izNkxoRa5v0tSg",
	"arraySection": "QWVEQQVpploexFcm4xYH"
};
export default ___CSS_LOADER_EXPORT___;
